<!-- Navbar section -->
<nav class="navbar navbar-expand-xl navbar-dark fixed-top bg-dark">
  <div class="container">
    <a class="navbar-brand" routerLink="/main">
      <img src="../../assets/img/logo1.png" alt="" width="50">
      <img src="../../assets/img/logo2.png" alt="" width="50">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <!--      <ng-container *ngIf="!mainPage">-->
      <ul class="navbar-nav me-auto mb-2 mb-md-0">
        <li class="nav-item">
          <a translate class="nav-link" [routerLink]="['/home']">kazakhstan.nav_main</a>
        </li>
        <li class="nav-item">
          <a translate class="nav-link" [routerLink]="['/about-us']">kazakhstan.nav_about_us</a>
        </li>
        <li class="nav-item">
          <a translate class="nav-link" [routerLink]="['/leadership']">kazakhstan.nav_leaderships</a>
        </li>
        <li class="nav-item">
          <a translate class="nav-link" [routerLink]="['/news']">kazakhstan.nav_news</a>
        </li>
        <li class="nav-item">
          <a translate class="nav-link" [routerLink]="['/winners']">kazakhstan.nav_winners</a>
        </li>
        <!--          <li class="nav-item">-->
        <!--            <a translate class="nav-link">kazakhstan.nav_partners</a>-->
        <!--          </li>-->
        <li class="nav-item">
          <a translate class="nav-link" [routerLink]="['/contacts']">kazakhstan.nav_contacts</a>
        </li>
      </ul>
      <!--      </ng-container>-->
      <form class="d-flex ml-auto">
        <div class="form-group" style="margin: 0.5rem;">
          <select class="select form-control" (ngModelChange)="selectLang($event)" [(ngModel)]="system.lang"
                  [ngModelOptions]="{standalone: true}">
            <option *ngFor="let x of langs" [ngValue]="x">{{x.name}}</option>
          </select>
        </div>
        <!--        <span translate (click)="redirectToAuth()" class="user"><i class="fa fa-user-circle-o" aria-hidden="true"></i>-->
        <!--					main.navbar_login</span>-->
      </form>
    </div>

  </div>
</nav>

<!--<ng-container >-->
<div *ngIf="(loader.isLoading$ | async)" class="spinner-overlay">
  <mat-spinner diameter="75"></mat-spinner>
</div>
<!--</ng-container>-->
<!--<ng-template #main>-->
<router-outlet></router-outlet>
<!--</ng-template>-->

<!-- Footer section -->
<footer class="footer mt-auto py-3">
  <div class="container">
    <div class="row">
      <div class="col-lg-5 text-center">
        <span translate>main.footer_text</span>
      </div>
      <div class="col-lg-4">
        <div class="socials text-center">
          <i class="fa fa-telegram" aria-hidden="true" (click)="openSocial('https://t.me/tgzqmlq')"></i>
          <i class="fa fa-instagram" aria-hidden="true" (click)="openSocial('https://instagram.com/9qumalaq_qazaqstan?igshid=MzRlODBiNWFlZA==')"></i>
          <i class="fa fa-facebook-official" aria-hidden="true" (click)="openSocial('https://m.facebook.com/groups/1648607052077380/?ref=share&mibextid=S66gvF')"></i>
          <i class="fa fa-youtube-play" aria-hidden="true"></i>
        </div>
      </div>
      <div class="col-lg-3 text-center">
        <span translate>main.footer_mail</span>
      </div>
    </div>
  </div>
</footer>
